import { useTheme } from '@mui/material';

export const MobileFriendlyIcon = () => {
    const theme = useTheme();
    const { stroke } = theme.colors.other.icon;

    return (
        <svg
            width={49}
            height={48}
            viewBox="0 0 49 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.625 10C17.5187 10 16.625 10.8937 16.625 12V36C16.625 37.1063 17.5187 38 18.625 38H30.625C31.7313 38 32.625 37.1063 32.625 36V12C32.625 10.8937 31.7313 10 30.625 10H18.625ZM14.625 12C14.625 9.79375 16.4188 8 18.625 8H30.625C32.8312 8 34.625 9.79375 34.625 12V36C34.625 38.2062 32.8312 40 30.625 40H18.625C16.4188 40 14.625 38.2062 14.625 36V12ZM24.625 32.5C25.0228 32.5 25.4044 32.658 25.6857 32.9393C25.967 33.2206 26.125 33.6022 26.125 34C26.125 34.3978 25.967 34.7794 25.6857 35.0607C25.4044 35.342 25.0228 35.5 24.625 35.5C24.2272 35.5 23.8456 35.342 23.5643 35.0607C23.283 34.7794 23.125 34.3978 23.125 34C23.125 33.6022 23.283 33.2206 23.5643 32.9393C23.8456 32.658 24.2272 32.5 24.625 32.5Z"
                fill={stroke.primary}
            />
        </svg>
    );
};
